(function() {
    'use strict';

    angular.module('app.widgets', ['matchMedia', 'ngCart','angularModalService','ui.tinymce','uiSwitch','lr.upload','ui.carousel']);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/widgets.module.js
 ** module id = 175
 ** module chunks = 0
 **/